import React from "react";
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta
          name="description"
          content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming."
        />
      </Helmet>

      <div className="policy-container">
        <div className="policy-content">
          <h1>Όροι και Προϋποθέσεις Χρήσης</h1>
          <p className="last-updated">
            Τελευταία ενημέρωση: {new Date().toLocaleDateString("el-GR")}
          </p>

          <section>
            <h2>1. Αποδοχή Όρων</h2>
            <p>
              Καλώς ήρθατε στο Fapugo Barbershop. Με την πρόσβαση και τη χρήση
              του ιστότοπού μας και των υπηρεσιών μας, αποδέχεστε και συμφωνείτε
              να δεσμεύεστε από τους παρόντες Όρους και Προϋποθέσεις. Εάν δεν
              συμφωνείτε με οποιονδήποτε από αυτούς τους όρους, παρακαλούμε μην
              χρησιμοποιείτε τον ιστότοπό μας.
            </p>
          </section>

          <section>
            <h2>2. Ορισμοί</h2>
            <ul>
              <li>
                <strong>"Εταιρεία", "εμείς", "μας"</strong> αναφέρεται στο
                Fapugo Barbershop
              </li>
              <li>
                <strong>"Ιστότοπος"</strong> αναφέρεται στο fapugo.com
              </li>
              <li>
                <strong>"Υπηρεσίες"</strong> αναφέρεται σε όλες τις υπηρεσίες
                κουρέματος και περιποίησης που προσφέρουμε
              </li>
              <li>
                <strong>"Χρήστης", "εσείς"</strong> αναφέρεται σε εσάς ως
                επισκέπτη ή πελάτη
              </li>
              <li>
                <strong>"Κράτηση"</strong> αναφέρεται στο ραντεβού που κάνετε
                μέσω του ιστότοπου
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Χρήση του Ιστότοπου</h2>
            <h3>3.1 Επιτρεπόμενη Χρήση</h3>
            <p>Μπορείτε να χρησιμοποιήσετε τον ιστότοπό μας για:</p>
            <ul>
              <li>
                Την περιήγηση και προβολή πληροφοριών για τις υπηρεσίες μας
              </li>
              <li>Την πραγματοποίηση κρατήσεων για ραντεβού</li>
              <li>Την επικοινωνία μαζί μας</li>
              <li>Την πρόσβαση στο προφίλ και το ιστορικό των κρατήσεών σας</li>
            </ul>

            <h3>3.2 Απαγορευμένες Δραστηριότητες</h3>
            <p>Δεν επιτρέπεται:</p>
            <ul>
              <li>Η χρήση του ιστότοπου για παράνομους σκοπούς</li>
              <li>Η προσπάθεια πρόσβασης σε μη εξουσιοδοτημένες περιοχές</li>
              <li>Η παρενόχληση άλλων χρηστών ή του προσωπικού μας</li>
              <li>
                Η αναπαραγωγή, αντιγραφή ή πώληση οποιουδήποτε μέρους του
                ιστότοπου
              </li>
              <li>Η υποβολή ψευδών ή παραπλανητικών πληροφοριών</li>
              <li>
                Η χρήση αυτοματοποιημένων συστημάτων για πρόσβαση στον ιστότοπο
              </li>
            </ul>
          </section>

          <section>
            <h2>4. Κρατήσεις και Ραντεβού</h2>
            <h3>4.1 Διαδικασία Κράτησης</h3>
            <p>
              Για να πραγματοποιήσετε κράτηση, πρέπει να παρέχετε ακριβείς και
              πλήρεις πληροφορίες επικοινωνίας. Η κράτηση θεωρείται
              επιβεβαιωμένη μόνο όταν λάβετε email ή SMS επιβεβαίωσης από εμάς.
            </p>

            <h3>4.2 Ακυρώσεις</h3>
            <p>
              Μπορείτε να ακυρώσετε το ραντεβού σας χωρίς χρέωση μέχρι 24 ώρες
              πριν από την προγραμματισμένη ώρα. Ακυρώσεις που γίνονται εντός 24
              ωρών ενδέχεται να υπόκεινται σε χρέωση ακύρωσης.
            </p>

            <h3>4.3 Αλλαγές Ραντεβού</h3>
            <p>
              Μπορείτε να αλλάξετε την ημερομηνία ή την ώρα του ραντεβού σας υπό
              την προϋπόθεση ότι υπάρχει διαθεσιμότητα. Οι αλλαγές πρέπει να
              γίνονται τουλάχιστον 12 ώρες πριν από το προγραμματισμένο
              ραντεβού.
            </p>

            <h3>4.4 Καθυστερήσεις</h3>
            <p>
              Παρακαλούμε να φτάνετε στην ώρα σας. Εάν καθυστερήσετε περισσότερο
              από 15 λεπτά, ενδέχεται να χρειαστεί να επαναπρογραμματίσουμε το
              ραντεβού σας ή να περιορίσουμε τον χρόνο της υπηρεσίας.
            </p>
          </section>

          <section>
            <h2>5. Τιμές και Πληρωμές</h2>
            <h3>5.1 Τιμολόγηση</h3>
            <p>
              Όλες οι τιμές που αναφέρονται στον ιστότοπο είναι σε Ευρώ (€) και
              περιλαμβάνουν ΦΠΑ όπου απαιτείται. Διατηρούμε το δικαίωμα να
              αλλάξουμε τις τιμές μας ανά πάσα στιγμή, αλλά οι αλλαγές δεν θα
              επηρεάσουν τις ήδη επιβεβαιωμένες κρατήσεις.
            </p>

            <h3>5.2 Μέθοδοι Πληρωμής</h3>
            <p>Αποδεχόμαστε τις ακόλουθες μεθόδους πληρωμής:</p>
            <ul>
              <li>Μετρητά (στο κατάστημα)</li>
              <li>Πιστωτικές και χρεωστικές κάρτες</li>
              <li>Ηλεκτρονικές πληρωμές</li>
            </ul>

            <h3>5.3 Προκαταβολές</h3>
            <p>
              Για ορισμένες premium υπηρεσίες ή ομαδικές κρατήσεις, ενδέχεται να
              απαιτείται προκαταβολή. Θα ενημερωθείτε για τυχόν απαιτήσεις
              προκαταβολής κατά την κράτηση.
            </p>
          </section>

          <section>
            <h2>6. Παροχή Υπηρεσιών</h2>
            <h3>6.1 Ποιότητα Υπηρεσιών</h3>
            <p>
              Δεσμευόμαστε να παρέχουμε υπηρεσίες υψηλής ποιότητας. Όλοι οι
              κουρείς μας είναι εκπαιδευμένοι επαγγελματίες με εμπειρία στις
              τελευταίες τεχνικές και τάσεις.
            </p>

            <h3>6.2 Διάρκεια Υπηρεσιών</h3>
            <p>
              Οι χρόνοι που αναφέρονται για κάθε υπηρεσία είναι ενδεικτικοί. Η
              πραγματική διάρκεια μπορεί να διαφέρει ανάλογα με τον τύπο μαλλιών
              και τις ανάγκες σας.
            </p>

            <h3>6.3 Αλλεργίες και Ευαισθησίες</h3>
            <p>
              Παρακαλούμε ενημερώστε μας για τυχόν αλλεργίες ή ευαισθησίες σε
              προϊόντα πριν από την έναρξη της υπηρεσίας. Δεν φέρουμε ευθύνη για
              αλλεργικές αντιδράσεις σε περίπτωση που δεν έχουμε ενημερωθεί.
            </p>
          </section>

          <section>
            <h2>7. Πνευματική Ιδιοκτησία</h2>
            <p>
              Όλο το περιεχόμενο του ιστότοπου, συμπεριλαμβανομένων αλλά όχι
              περιορισμένων σε κείμενα, γραφικά, λογότυπα, εικόνες, βίντεο και
              λογισμικό, είναι ιδιοκτησία του Fapugo Barbershop και
              προστατεύεται από τους νόμους περί πνευματικής ιδιοκτησίας.
              Απαγορεύεται η αναπαραγωγή χωρίς γραπτή άδεια.
            </p>
          </section>

          <section>
            <h2>8. Εγγύηση Ικανοποίησης</h2>
            <p>
              Η ικανοποίησή σας είναι η προτεραιότητά μας. Εάν δεν είστε
              ευχαριστημένοι με την υπηρεσία σας, παρακαλούμε ενημερώστε μας
              αμέσως. Θα καταβάλουμε κάθε προσπάθεια να διορθώσουμε το πρόβλημα
              χωρίς επιπλέον χρέωση.
            </p>
          </section>

          <section>
            <h2>9. Περιορισμός Ευθύνης</h2>
            <p>
              Στο μέγιστο βαθμό που επιτρέπεται από το νόμο, το Fapugo
              Barbershop δεν φέρει ευθύνη για:
            </p>
            <ul>
              <li>Έμμεσες ή επακόλουθες ζημίες</li>
              <li>Απώλεια κερδών ή εσόδων</li>
              <li>Απώλεια δεδομένων ή πληροφοριών</li>
              <li>Διακοπή εργασιών</li>
              <li>
                Ζημίες που προκύπτουν από τη χρήση ή την αδυναμία χρήσης του
                ιστότοπου
              </li>
            </ul>
          </section>

          <section>
            <h2>10. Αποποίηση Ευθύνης</h2>
            <p>
              Ο ιστότοπος και οι υπηρεσίες παρέχονται "ως έχουν" χωρίς εγγυήσεις
              οποιουδήποτε είδους. Δεν εγγυόμαστε ότι ο ιστότοπος θα λειτουργεί
              χωρίς διακοπές ή σφάλματα.
            </p>
          </section>

          <section>
            <h2>11. Προστασία Δεδομένων</h2>
            <p>
              Η χρήση των προσωπικών σας δεδομένων διέπεται από την Πολιτική
              Απορρήτου μας. Με τη χρήση του ιστότοπου, συμφωνείτε με τη συλλογή
              και χρήση πληροφοριών σύμφωνα με την πολιτική αυτή.
            </p>
          </section>

          <section>
            <h2>12. Υγεία και Ασφάλεια</h2>
            <p>
              Λαμβάνουμε όλα τα απαραίτητα μέτρα υγείας και ασφάλειας σύμφωνα με
              την ισχύουσα νομοθεσία. Όλα τα εργαλεία μας απολυμαίνονται μετά
              από κάθε χρήση και διατηρούμε υψηλά πρότυπα καθαριότητας.
            </p>
          </section>

          <section>
            <h2>13. Ανωτέρα Βία</h2>
            <p>
              Δεν φέρουμε ευθύνη για την αδυναμία εκτέλεσης των υποχρεώσεών μας
              λόγω περιστάσεων που βρίσκονται πέραν του εύλογου ελέγχου μας,
              όπως φυσικές καταστροφές, πανδημίες, απεργίες ή κυβερνητικές
              πράξεις.
            </p>
          </section>

          <section>
            <h2>14. Τροποποιήσεις Όρων</h2>
            <p>
              Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτούς τους όρους ανά
              πάσα στιγμή. Οι αλλαγές τίθενται σε ισχύ αμέσως μετά τη δημοσίευσή
              τους στον ιστότοπο. Η συνεχής χρήση του ιστότοπου μετά από
              τροποποιήσεις συνιστά αποδοχή των νέων όρων.
            </p>
          </section>

          <section>
            <h2>15. Διαχωρισιμότητα</h2>
            <p>
              Εάν οποιαδήποτε διάταξη αυτών των όρων κριθεί άκυρη ή μη
              εφαρμόσιμη, οι υπόλοιπες διατάξεις παραμένουν σε πλήρη ισχύ.
            </p>
          </section>

          <section>
            <h2>16. Εφαρμοστέο Δίκαιο</h2>
            <p>
              Αυτοί οι όροι διέπονται και ερμηνεύονται σύμφωνα με τους νόμους
              της Ελληνικής Δημοκρατίας. Οποιαδήποτε διαφορά που προκύπτει από
              αυτούς τους όρους θα υπόκειται στην αποκλειστική δικαιοδοσία των
              δικαστηρίων της Αθήνας.
            </p>
          </section>

          <section>
            <h2>17. Επικοινωνία</h2>
            <p>
              Για οποιεσδήποτε ερωτήσεις σχετικά με αυτούς τους όρους,
              παρακαλούμε επικοινωνήστε μαζί μας:
            </p>
            <ul>
              <li>
                Email:{" "}
                <a href="mailto:fapugo@hotmail.com">fapugo@hotmail.com</a>
              </li>
              <li>
                <a href="https://wa.me/302101234567">WhatsApp</a>
              </li>
              <li>
                <a href="https://viber.me/302101234567">Viber</a>
              </li>
              <li>Τηλέφωνο: +30 210 123 4567</li>
              <li>Διεύθυνση: Αθήνα, Ελλάδα</li>
            </ul>
          </section>

          <section>
            <h2>18. Αποδοχή Όρων</h2>
            <p>
              Με την πραγματοποίηση κράτησης ή τη χρήση των υπηρεσιών μας,
              επιβεβαιώνετε ότι έχετε διαβάσει, κατανοήσει και αποδεχτεί αυτούς
              τους Όρους και Προϋποθέσεις στο σύνολό τους.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
